<script lang="ts" setup>
import {themeConfig} from "@themeConfig";
import {VNodeRenderer} from "@layouts/components/VNodeRenderer";
import {VForm} from "vuetify/components/VForm";

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})
const route = useRoute('reset-key')
const key = ref(route.params.key)

const refVForm = ref<VForm>()
const form = ref({
  compNo: 'nstc',
  email: '',
  userNo: '',
  password: '',
  chkPassword: '',
  key: ''
})

const isPasswordVisible = ref(false)
const isChkPasswordVisible = ref(false)

const successMessage = ref('')
const errorMessage = ref('')

const formIsValid = computed(() => form.value.password != '' && form.value.password == form.value.chkPassword);

const errors = ref<Record<string, string | undefined>>({
  email: undefined,
  password: undefined,
})

const res = await $api('/du/user/password/checkLink', {
  method: 'POST',
  query: {
    key: key.value
  },
  onResponse({ response }) {
    console.log('checkLink success response', response)
    if (response.status == 200) {
      form.value.userNo = response._data.userNo
      form.value.email = response._data.email
    }
  },
  onResponseError({ response }) {
    console.log('checkLink error response', response)
  },
})

const resetPwd = async () => {
  try {
    const res = await $api('/du/user/password/resetByKey', {
      method: 'POST',
      body: {
        userNo: form.value.userNo,
        newPwd: form.value.password,
        newPwdCheck: form.value.chkPassword,
        key: key.value
      },
      onResponse(context) {
        successMessage.value = '密碼修改完成，請以新密碼重新登入'
        setTimeout(() => {
          location.href = location.origin
        }, 2000)
      },
      onResponseError({ response }) {
        errors.value = response._data.errors
        errorMessage.value = response._data.message
      },
    })

  }
  catch (err) {
    console.error(err)
  }
}

const onSubmit = () => {
  refVForm.value?.validate()
    .then(({ valid: isValid }) => {
      if (isValid)
        resetPwd()
    })
}


</script>
<template>
  <VContainer class="d-flex justify-center align-center" fluid style="min-height: 100vh;">
    <VRow class="d-flex justify-center">
      <VCol cols="12" md="6" lg="4">
        <VCard class="pa-5">
          <VCardTitle class="text-center"><VNodeRenderer class="text-center" :nodes="themeConfig.app.logo" /></VCardTitle>
          <VCardTitle class="text-center">重新設定密碼</VCardTitle>
          <VAlert
            variant="outlined"
            color="success"
            v-if="successMessage != ''"
          >
            {{ successMessage }}
          </VAlert>
          <VAlert
            variant="outlined"
            color="error"
            v-if="errorMessage != ''"
          >
            {{ errorMessage }}
          </VAlert>
          <VForm ref="refVForm"
                 @submit.prevent="onSubmit">
            <!-- 帳號 -->
            <VRow>
              <VCol cols="12">
                <AppTextField
                  v-model="form.userNo"
                  label="帳號"
                  placeholder="請輸入您的電子信箱"
                  outlined
                  dense
                  disabled
                />
              </VCol>
            </VRow>
            <!-- 電子信箱 -->
            <VRow>
              <VCol cols="12">
                <AppTextField
                  v-model="form.email"
                  label="電子信箱"
                  placeholder="請輸入您的電子信箱"
                  outlined
                  dense
                  disabled
                />
              </VCol>
            </VRow>



            <!-- 密碼 -->
            <VRow>
              <VCol cols="12">
                <AppTextField
                  v-model="form.password"
                  label="新密碼"
                  placeholder="············"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  :append-inner-icon="isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
                  @click:append-inner="isPasswordVisible = !isPasswordVisible"
                  :rules="[requiredValidator, passwordValidator]"
                />
              </VCol>
            </VRow>

            <!-- 確認密碼 -->
            <VRow>
              <VCol cols="12">
                <AppTextField
                  v-model="form.chkPassword"
                  label="確認密碼"
                  placeholder="············"
                  :type="isChkPasswordVisible ? 'text' : 'password'"
                  :append-inner-icon="isChkPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
                  @click:append-inner="isChkPasswordVisible = !isChkPasswordVisible"
                  :rules="[requiredValidator, confirmedValidator(form.chkPassword, form.password)]"
                />
              </VCol>
            </VRow>

            <!-- 註冊按鈕 -->
            <VRow>
              <VCol cols="12">
                <VBtn :disabled="!formIsValid" block color="primary" type="submit">
                  確認
                </VBtn>
              </VCol>
            </VRow>
            <VRow>
              <VCol cols="12" class="text-center">
                <a href="/login" class="text-decoration-none">返回登入頁面</a>
              </VCol>
            </VRow>
          </VForm>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>
